/* ============================================================
   Vyelle — Global JS
   ============================================================ */

// 1. Scroll-reveal animation
// Fade in sections as they enter viewport
(function() {
  'use strict';
  
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vy-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  function initReveal() {
    var sections = document.querySelectorAll(
      '.vy-hero, .vy-shift, .vy-qualifier, .vy-why-generic, ' +
      '.vy-pillars, .vy-formula, .vy-ritual, .vy-manifesto, ' +
      '.vy-promise, .vy-faq, .vy-final-cta'
    );
    sections.forEach(function(el) {
      el.classList.add('vy-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

// 2. Smooth scroll
document.documentElement.style.scrollBehavior = 'smooth';
